import React from 'react';
import './DestinationOverview.css';

function DestinationOverview({ destination }) {
  return (
    <section className="destination-overview">
      <div className="destination-overview-container">
        <div className="destination-overview-content">
          <h2 className="destination-overview-title">About {destination.name}</h2>
          <p className="destination-overview-description">
            {destination.fullDescription}
          </p>
          {destination.whyVisit && (
            <div className="why-visit-section">
              <h3 className="why-visit-title">Why Visit {destination.name}?</h3>
              <p className="why-visit-text">{destination.whyVisit}</p>
            </div>
          )}
        </div>
        
        <div className="destination-overview-stats">
          <div className="overview-stat">
            <svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
              <path d="M21 10c0 7-9 13-9 13s-9-6-9-13a9 9 0 0 1 18 0z"/>
              <circle cx="12" cy="10" r="3"/>
            </svg>
            <h3 className="stat-value">{destination.size}</h3>
            <p className="stat-label">Total Area</p>
          </div>
          <div className="overview-stat">
            <svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
              <rect x="3" y="4" width="18" height="18" rx="2" ry="2"/>
              <line x1="16" y1="2" x2="16" y2="6"/>
              <line x1="8" y1="2" x2="8" y2="6"/>
              <line x1="3" y1="10" x2="21" y2="10"/>
            </svg>
            <h3 className="stat-value">{destination.established}</h3>
            <p className="stat-label">Established</p>
          </div>
          <div className="overview-stat">
            <svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
              <path d="M12 2L2 7l10 5 10-5-10-5z"/>
              <path d="M2 17l10 5 10-5M2 12l10 5 10-5"/>
            </svg>
            <h3 className="stat-value">{destination.wildlife.length}+</h3>
            <p className="stat-label">Wildlife Species</p>
          </div>
          <div className="overview-stat">
            <svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
              <circle cx="12" cy="12" r="10"/>
              <polyline points="12 6 12 12 16 14"/>
            </svg>
            <h3 className="stat-value">{destination.duration}</h3>
            <p className="stat-label">Recommended Stay</p>
          </div>
        </div>
      </div>
    </section>
  );
}

export default DestinationOverview;

